import React from "react";
import { Alert } from "@amzn/awsui-components-console";

export const ASSOCIATE_NOT_FOUND_HEADER = "Associate Not Found";

/**
 * Body content of the "Associate Not Found" banner, shared by the WC
 * pre-screen (inside `AssociateNotFoundBanner`) and the legacy WC form
 * (via the `CUSTOM_ERRORS` registry) so the copy cannot drift between
 * the two surfaces.
 */
export const AssociateNotFoundContent = (): JSX.Element => (
  <div>
    <div>The associate could not be located in the system. Before proceeding:</div>
    <ul>
      <li>
        Verify the associate&apos;s <strong>employment type</strong> and{" "}
        <strong>badge color</strong>
      </li>
      <li>
        Confirm the associate is <strong>in scope</strong> for this workflow
      </li>
      <li>
        <strong>Yellow Badge (Contingent Workers):</strong> A claim will not be initiated through
        Nucleus for yellow badge associates. At the conclusion of care, the first aider or OCP
        should notify the site WHSM (or designee), who will coordinate with the worker&apos;s
        employer to ensure all pertinent information is shared &mdash; including the mechanism of
        injury or illness and how the incident reportedly occurred.
      </li>
    </ul>
  </div>
);

export interface AssociateNotFoundBannerProps {
  /** Optional `data-testid` applied to the alert element. */
  testId?: string;
}

/**
 * Error banner shown when an associate lookup returns no record at all.
 * Distinct from the "Site not found" error, which applies when the
 * associate exists but their home site is not launched in Nucleus.
 */
function AssociateNotFoundBanner({ testId }: AssociateNotFoundBannerProps): JSX.Element {
  return (
    <Alert
      type="error"
      header={ASSOCIATE_NOT_FOUND_HEADER}
      statusIconAriaLabel="Error"
      data-testid={testId}
    >
      <AssociateNotFoundContent />
    </Alert>
  );
}

export default AssociateNotFoundBanner;
